import { render } from "./index-five.vue?vue&type=template&id=01d3491c"
import script from "./index-five.vue?vue&type=script&lang=js"
export * from "./index-five.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__